import React from 'react';

import { FlagsProvider } from '@atlaskit/flag/flags-provider';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditAttachmentField } from './edit';
import { ViewAttachmentField } from './view';

export const AttachmentField = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	const renderMode = useFormRenderMode();

	switch (renderMode) {
		case FormRenderMode.EDIT:
			return (
				<FlagsProvider>
					<EditAttachmentField
						fieldId={fieldId}
						fieldInputId={fieldInputId}
						fieldLabelId={fieldLabelId}
						fieldErrorId={fieldErrorId}
					/>
				</FlagsProvider>
			);
		default:
			return (
				<ViewAttachmentField
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
	}
};
